import React, { Fragment, useEffect, useState } from 'react';
import styles from './Component.module.scss';
import { renderTableData } from './factory/factory';
import Checkbox from 'component/atom/forms/checkbox/Checkbox';
import NoData from './NoData/NoData';
import { usePost } from 'hooks/usePost';
import Button from 'component/atom/forms/button/Button';
import { useBrandingContext } from 'app-context/BrandingsContext';
import ConfirmationModal from 'component/hoc/success-modal/ConfirmationModal';
import Tooltip from 'component/Custom/tooltip/Tooltip';
import { addOpacityToColor } from 'helpers/addOpacityToColor';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import Loader from 'component/atom/loader/Loader';
import Modal from 'component/hoc/modal/Modal';

const RenderTableHeader = ({
  headerData,
  setQuery,
  query,
  rowButtons,
  renderAdditionalComponent = null,
  tableHeaderClassName,
}) => {
  const handleSort = (header) => {
    const capitalizeFirstLetter = (header) => {
      return (
        header.fieldName.charAt(0).toUpperCase() + header.fieldName.slice(1)
      );
    };

    setQuery((prevQuery) => {
      const isCurrentSort = !prevQuery.desc ?? false;
      return {
        ...prevQuery,
        sortBy: capitalizeFirstLetter(header),
        desc: isCurrentSort ?? false,
      };
    });
  };
  const additionalIconLength = rowButtons?.length || 0;

  return (
    <thead className={styles['table-header']}>
      <tr>
        {headerData?.fields?.map((header) => {
          return (
            <th
              key={header.fieldName}
              className={`${header.isPrimary ? styles['primary-item'] : ''} ${
                headerData?.isEdge
                  ? `${styles['bordered-edge']} ${styles['bordered-edge-header']}`
                  : ''
              } ${tableHeaderClassName ? tableHeaderClassName : ''}`}
            >
              <div className={styles.headerIcon}>
                <p className={styles.headerTitle}>{header.headerName} </p>
                {header.hasSort ? (
                  <SvgWithBranding
                    type='sort'
                    className={styles['icon']}
                    color={'#011211'}
                    onClick={() => header.hasSort && handleSort(header)}
                  />
                ) : null}
              </div>
            </th>
          );
        })}
        {headerData?.hasDelete ||
        headerData?.hasEdit ||
        headerData?.isExpandable ||
        renderAdditionalComponent !== null ||
        additionalIconLength != 0 ? (
          <th
            colSpan={
              additionalIconLength +
              (headerData?.hasDelete ? 1 : 0) +
              (headerData?.hasEdit ? 1 : 0) +
              (headerData?.isExpandable ? 1 : 0) +
              (renderAdditionalComponent !== null ? 1 : 0)
            }
            className={`${
              headerData?.isEdge
                ? `${styles['bordered-edge']} ${styles['bordered-edge-header']}`
                : ''
            } ${
              headerData?.actionTitle ? `${styles['actions-table-header']}` : ''
            }`}
          >
            {headerData?.actionTitle ? headerData?.actionTitle : null}
          </th>
        ) : null}
      </tr>
    </thead>
  );
};

const RenderTableBody = ({
  data,
  headerData,
  selectedItems,
  setSelectedItems,
  actions,
  onDeleteSuccess, //if u want to pass refetch on success
  rowButtons,
  hasData,
  rowKey,
  api,
  refetch,
  isFetching,
  isKnowledgeBase,
  renderAdditionalComponent,
  hasAction,
  hasFileModal,
  noDataText,
  noDataIcon,
}) => {
  const { brandingData } = useBrandingContext();
  const { page_ButtonColor } = brandingData;
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [expandedRows, setExpandedRows] = useState([]);
  const [hoveredRowId, setHoveredRowId] = useState(null);
  const [switchConfirm, setSwitchConfirm] = useState(false);
  const [selectedSwitch, setSelectedSwitch] = useState(null);
  const [fileModalOpen, setFileModalOpen] = useState(false);
  const [fileUrl, setFileUrl] = useState('');
  const [fileName, setFileName] = useState('');
  const [previewFailed, setPreviewFailed] = useState(false);

  const [item, setItem] = useState(null);
  const { mutate: Delete, isPending } = usePost({
    onSuccessToast: api?.delete?.toast
      ? api.delete.toast
      : 'Deleted Successfully',
    toastType: 'add',
  });
  const { mutate: Switch } = usePost({
    onSuccessToast: 'Updated Successfully',
    toastType: 'update',
    onErrorToast: api?.toggleToast?.error,
  });
  const additionalIconLength = rowButtons?.length || 0;
  const handleRowClick = (func, item) => {
    if (typeof func === 'function') {
      func(item);
    }
  };

  const handleEdit = (e, func, item) => {
    e.stopPropagation();
    if (func === null) return;
    if (typeof func === 'function') {
      func(item);
    }
  };

  const handleAddMembers = (e, func, item) => {
    e.stopPropagation();
    if (func === null) return;
    if (typeof func === 'function') {
      func(item);
    }
  };

  const handleDelete = () => {
    // this is for knowledge base because it has different delete url for folder and file
    const deleteUrl = isKnowledgeBase
      ? item.isFolder
        ? api.delete.url(item[rowKey])
        : api.delete.fileUrl(item[rowKey])
      : api.delete.url(item[rowKey]);

    Delete({ method: 'DELETE', url: deleteUrl }, { onSuccess: refetch });
  };

  const handleAdditionalIcon = (e, func, item) => {
    e.stopPropagation();
    if (func === null) return;
    if (typeof func === 'function') {
      func(item);
    }
  };
  const handleCheckbox = (e) => {
    e.stopPropagation();
  };

  const toggleCheckUser = (itemId) => {
    setSelectedItems((prevSelectedItems) => {
      const newSelectedItems = prevSelectedItems?.includes(itemId)
        ? prevSelectedItems?.filter((id) => id !== itemId)
        : [...prevSelectedItems, itemId];

      return newSelectedItems;
    });
  };

  const handleSwitchClick = (id, status) => {
    if (api.toggleConfirm && status) {
      setSelectedSwitch({ id, status });
      setSwitchConfirm(true);
    } else {
      handleSwitch(id, status);
    }
  };

  const handleSwitch = (id, status) => {
    if (api?.toggleUrl) {
      Switch(
        {
          url: api?.toggleUrl(id, !status),
          method: 'Put',
        },
        {
          onSuccess: () => {
            refetch();
          },
        },
      );
    }
  };
  //this function are for delete functionality
  const handleOpenModal = (e, item) => {
    e.stopPropagation();
    setItem(item);
    setIsDeleteModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsDeleteModalOpen(false);
  };

  const toggleRow = (rowId) => {
    setExpandedRows((prev) =>
      prev.includes(rowId)
        ? prev.filter((id) => id !== rowId)
        : [...prev, rowId],
    );
  };

  const handleIframeError = () => {
    setPreviewFailed(true);
  };

  const methodStyleMap = {
    2: '#01931A',
    1: '#0744E1',
    4: '#E19107',
    3: '#C81111',
  };

  const getMethodStyle = (method) => {
    const color = methodStyleMap[method];
    return color ? { color, fontSize: '16px', fontWeight: 500 } : {};
  };

  const getStatusPillStyle = (status) => {
    const map = {
      success: { backgroundColor: '#EAFFEE', color: '#01931A' },
      ok: { backgroundColor: '#EAFFEE', color: '#01931A' },
      failed: { backgroundColor: '#FFE1E1', color: '#C81111' },
      'in progress': { backgroundColor: '#FFF2D5', color: '#EC6B01' },
    };

    const key = status?.toLowerCase();
    return {
      ...(map[key] || { backgroundColor: '#F0F0F0', color: '#666' }),
    };
  };

  const openFileModal = (url) => {
    setFileUrl(url);
    const name = url.split('/').pop();
    setFileName(name);
    setFileModalOpen(true);
  };

  const getStatusIcon = (status) => {
    const key = status?.toLowerCase();
    switch (key) {
      case 'success':
        return 'success';
      case 'ok':
        return 'success';
      case 'failed':
        return 'failed';
      case 'in progress' || 'ok':
        return 'inProgress';
      default:
        return 'info';
    }
  };

  // put these near your component
  const getFilenameFromHeaders = (res, fallback) => {
    const cd = res.headers.get('content-disposition') || '';
    const match = /filename\*?=(?:UTF-8''|")?([^\";]+)/i.exec(cd);
    try {
      return match ? decodeURIComponent(match[1].replace(/"/g, '')) : fallback;
    } catch {
      return fallback;
    }
  };

  const handleDownloadFile = async (url, fallbackName) => {
    try {
      const res = await fetch(url, {
        // tweak these if your API needs auth/cookies:
        // credentials: 'include',
        // headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const blob = await res.blob();
      const name = getFilenameFromHeaders(res, fallbackName || 'file');
      const objectUrl = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = objectUrl;
      a.download = name;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(objectUrl);
    } catch (e) {
      // fallback: open in new tab if download blocked
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  // stable row id even when `rowKey` duplicates
  const getRowId = (item, i) => {
    const primary = item?.[rowKey];
    const stamp =
      item?.dateCreated ||
      item?.createdOn ||
      item?.updatedOn ||
      item?.chatId ||
      item?.id ||
      item?.Id ||
      item?.ID;

    if (primary != null && primary !== '') {
      return `${primary}__${stamp ?? ''}`;
    }

    return `${String(stamp ?? '')}__${i}`;
  };

  return (
    <>
      <tbody>
        {isFetching ? (
          <tr style={{ backgroundColor: 'transparent' }}>
            <td
              colSpan={
                headerData?.fields?.length +
                (headerData?.hasCheckbox ? 1 : 0) +
                additionalIconLength +
                (headerData?.hasDelete ? 1 : 0) +
                (headerData?.hasEdit ? 1 : 0) +
                (headerData?.isExpandable ? 1 : 0) +
                (renderAdditionalComponent ? 1 : 0)
              }
            >
              <Loader isComponent />
            </td>
          </tr>
        ) : !hasData || data?.length == 0 ? (
          <tr
            style={{ backgroundColor: 'transparent' }}
            className={styles.noData}
          >
            <td
              colSpan={
                headerData?.fields?.length +
                (headerData?.hasCheckbox ? 1 : 0) +
                additionalIconLength +
                (headerData?.hasDelete ? 1 : 0) +
                (headerData?.hasEdit ? 1 : 0) +
                (headerData?.isExpandable ? 1 : 0) +
                (renderAdditionalComponent ? 1 : 0)
              }
            >
              <div
                style={{
                  height: '50vh',
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <NoData
                  text={noDataText}
                  type={noDataIcon}
                  containerStyle={{ width: '500px' }}
                />
              </div>
            </td>
          </tr>
        ) : (
          data?.map((item, index) => {
            const rowId = getRowId(item, index);
            const isExpanded = expandedRows.includes(rowId);
            const syncing =
              renderAdditionalComponent &&
              renderAdditionalComponent({
                header: headerData,
                item,
                returnSyncStateOnly: true,
              });

            return (
              <Fragment key={rowId}>
                <tr
                  onMouseEnter={() => setHoveredRowId(rowId)}
                  onMouseLeave={() => setHoveredRowId(null)}
                  onClick={() =>
                    handleRowClick(actions?.onRowClick?.func, item)
                  }
                  style={{
                    cursor: actions?.onRowClick?.hasRowClick
                      ? 'pointer'
                      : 'cursor',
                  }}
                >
                  {headerData?.fields?.map((header, colIdx) => {
                    const isFirstExpandableCell =
                      headerData?.isExpandable && colIdx === 0;

                    return (
                      <td
                        key={header.fieldName ?? colIdx}
                        style={{
                          whiteSpace: isExpanded ? 'normal' : 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          maxWidth: header?.isBadge ? '100%' : '300px',
                          overflowWrap: isExpanded ? 'break-word' : 'unset',
                        }}
                      >
                        {header.fieldName === 'status' &&
                        headerData?.tableName === 'API logs' ? (
                          <div
                            className={styles.pill}
                            style={getStatusPillStyle(item[header.fieldName])}
                          >
                            <SvgWithBranding
                              type={getStatusIcon(item[header.fieldName])}
                              width={16}
                              height={16}
                            />
                            <span>
                              {'OK' === item[header.fieldName]
                                ? 'success'
                                : item[header.fieldName]}
                            </span>
                          </div>
                        ) : (
                          <div className={styles.cellItem}>
                            {headerData?.hasCheckbox && 0 === colIdx ? (
                              <div
                                className={styles.checkbox}
                                onClick={(e) => handleCheckbox(e)}
                              >
                                {(api?.delete?.blockDelete
                                  ? item.roleId !== 0
                                  : true) && (
                                  <Checkbox
                                    ischecked={
                                      selectedItems?.includes(rowId) ||
                                      (hoveredRowId === rowId &&
                                        !selectedItems?.includes(rowId))
                                    }
                                    onChange={() => toggleCheckUser(rowId)}
                                    boxClassName={styles['checkbox-box']}
                                  />
                                )}
                              </div>
                            ) : null}
                            <span
                              style={{
                                ...(header.fieldName === 'type'
                                  ? getMethodStyle(item[header.fieldName])
                                  : {}),
                                ...(header.fieldName === 'endpoint'
                                  ? {
                                      fontFamily: '"Fira Code", monospace',
                                      fontSize: '16px',
                                    }
                                  : {}),
                              }}
                              className={
                                isFirstExpandableCell &&
                                styles.expandableFirstCellText
                              }
                            >
                              {renderTableData({
                                item,
                                header: {
                                  ...header,
                                  onOpenFileModal: openFileModal,
                                },
                                handleSwitch: handleSwitchClick,
                                rowKey,
                                tableName: headerData?.tableName,
                                hasCheckbox: headerData?.hasCheckbox,
                                index: index,
                                blockDelete: !item.roleId,
                                hasFileModal: hasFileModal,
                                isFirstExpandableCell: isFirstExpandableCell,
                              })}
                            </span>
                          </div>
                        )}
                      </td>
                    );
                  })}

                  {headerData?.isExpandable && (
                    <td className={styles['arrow-container']}>
                      <SvgWithBranding
                        type='arrow'
                        className={`${styles.arrow} ${
                          isExpanded ? styles.up : styles.down
                        }`}
                        onClick={() => toggleRow(rowId)}
                      />
                    </td>
                  )}
                  {headerData?.hasDelete ||
                  headerData?.hasEdit ||
                  headerData?.hasDefault ||
                  headerData?.hasTryMe ||
                  rowButtons?.length > 0 ||
                  (renderAdditionalComponent !== null &&
                    renderAdditionalComponent !== undefined) ? (
                    <td
                      colSpan={
                        additionalIconLength +
                        (headerData?.hasDelete ? 2 : 0) +
                        (headerData?.hasEdit ? 2 : 0)
                      }
                    >
                      {/*send type : icon or button   */}

                      <div
                        className={`${styles.imgCont} ${
                          hasAction && styles.hasAction
                        }`}
                      >
                        {rowButtons?.length > 0
                          ? rowButtons?.map((icon, index) => {
                              return icon.type == 'icon' ? (
                                <Tooltip
                                  content={icon.iconTooltip}
                                  key={index}
                                  disabled={icon.iconTooltip ? true : false}
                                >
                                  <SvgWithBranding
                                    type={icon.name}
                                    onClick={(e) =>
                                      handleAdditionalIcon(e, icon?.func, item)
                                    }
                                    className={`${styles.icon} `}
                                    key={index}
                                  />
                                </Tooltip>
                              ) : (
                                <Button
                                  label={icon.label}
                                  variant={icon.variant}
                                  type={icon.svgType ?? ''}
                                  onClick={(e) =>
                                    handleAdditionalIcon(e, icon?.func, item)
                                  }
                                  opicBackground
                                  key={index}
                                />
                              );
                            })
                          : null}

                        {renderAdditionalComponent
                          ? renderAdditionalComponent({
                              header: headerData,
                              item: item,
                            })
                          : null}
                        {(headerData?.hasDelete || headerData?.hasEdit) && (
                          <>
                            {headerData?.hasAddMembers &&
                              (headerData?.isEditDeleteDefault
                                ? !item['isDefault']
                                : true) && (
                                <Tooltip content='Manage Members'>
                                  <SvgWithBranding
                                    type='add-member'
                                    onClick={(e) =>
                                      handleAddMembers(
                                        e,
                                        actions?.hasAddMembers?.func,
                                        item,
                                      )
                                    }
                                    className={`${styles.icon} ${styles.addMemberIcon}`}
                                  />
                                </Tooltip>
                              )}
                            {headerData?.hasEdit &&
                              (headerData?.isEditDeleteDefault
                                ? !item['isDefault']
                                : true) && (
                                <Tooltip content='Edit'>
                                  <SvgWithBranding
                                    type='edit'
                                    onClick={(e) =>
                                      handleEdit(
                                        e,
                                        actions?.hasEdit?.func,
                                        item,
                                      )
                                    }
                                    className={`${styles.icon} ${styles.editIcon}`}
                                  />
                                </Tooltip>
                              )}

                            {headerData?.hasDelete &&
                              (!isKnowledgeBase || !item?.isURL) &&
                              (headerData?.isEditDeleteDefault
                                ? !item['isDefault']
                                : true) &&
                              (headerData?.isSystem
                                ? !item['isSystem']
                                : true) &&
                              (api?.delete?.blockDelete
                                ? item.roleId !== 0
                                : true) && (
                                <Tooltip content='Delete' red>
                                  <SvgWithBranding
                                    type='delete2'
                                    onClick={(e) => handleOpenModal(e, item)}
                                    className={`${styles.icon} ${styles['delete-icon']}`}
                                  />
                                </Tooltip>
                              )}
                          </>
                        )}
                      </div>
                    </td>
                  ) : null}
                </tr>
                {syncing && syncing.syncing && (
                  <tr className={styles.syncBarRow}>
                    <td colSpan={headerData.fields.length + 1}>
                      <div className={styles.fullSyncBarWrapper}>
                        <div className={styles.syncingBarContainer}>
                          <div
                            className={styles.syncingBar}
                            style={{ width: `${syncing.progress}%` }}
                          ></div>
                        </div>
                        <div className={styles.syncPercentText}>
                          {syncing.progress}% complete
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </Fragment>
            );
          })
        )}
      </tbody>
      <ConfirmationModal
        isOpen={isDeleteModalOpen}
        onClose={handleCloseModal}
        onSubmit={handleDelete}
        closeOnSubmit={true}
        onApproveButton={{ text: 'delete' }}
        text='Delete'
        subText={headerData?.deleteSubtext}
        type='delete'
        isLoading={isPending}
      />
      <ConfirmationModal
        isOpen={switchConfirm}
        onClose={() => setSwitchConfirm(false)}
        onSubmit={() => {
          if (selectedSwitch) {
            handleSwitch(selectedSwitch.id, selectedSwitch.status);
          }
          setSwitchConfirm(false);
        }}
        closeOnSubmit={true}
        onApproveButton={{ text: 'confirm' }}
        text='Deactivate'
        subText={api?.toggleToast?.deactivate}
        isLoading={isPending}
      />
      <Modal
        isOpen={fileModalOpen}
        onClose={() => setFileModalOpen(false)}
        title={fileName}
        classname={styles['file-modal']}
        exitComponent={
          <Button
            label='Download'
            type='download'
            onClick={() => handleDownloadFile(fileUrl, fileName)}
          />
        }
      >
        {previewFailed ? (
          <p className={styles['preview-fallback']}>
            Preview unavailable — Download to view
          </p>
        ) : (
          <iframe
            src={`${fileUrl}#toolbar=0&navpanes=0&scrollbar=0`}
            style={{ width: '100%', height: '800px', border: 'none' }}
            title={fileName}
            onError={handleIframeError}
          />
        )}
      </Modal>
    </>
  );
};

export { RenderTableHeader, RenderTableBody };
